import {getToken} from "../Utils/Common";

/***
 * adds the item to ignoreList
 * @param item bson document
 * @returns {Promise<Response>} json
 */
export function addIgnoreListItem(item) {


    return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/v2/resources/addignoreitem`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + getToken()},
        body: JSON.stringify(item)
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

/***
 * deletes an item from the ignoreList
 * @param id index Object ID
 * @returns {Promise<Response>} Error or success
 */
export function deleteIgnoreListItem(id) {


    return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/v2/resources/deleteignoreitem/`+ id, {
        method: 'DELETE',
        headers: {
            'Authorization': 'Bearer ' + getToken()},
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

/***
 * Get all items from the ignore list
 * @returns {Promise<Response>} Array of objects
 */
export function getIgnoreListData() {

    return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/v2/resources/ignorelist`, {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + getToken(),
        },
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function getTrackAIFromBackend(lvid) {
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/get_ai_track`+'/'+lvid, {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + getToken()},
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function getTrackAItoBackend(lvid,data) {

    let aiSavedata={
            "lv_id": lvid,
            "tracking_info": data
        }
        console.log(aiSavedata)
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/save_ai_track`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + getToken()},
        body: JSON.stringify(aiSavedata)
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}